import { MarkdownLite } from "@/lib/markdown-lite";
import { groupMessagesByDay, type MessageItem } from "@/lib/messages";
import { RoleChip } from "@/components/messages/ConversationRow";

export function MessageList({ messages }: { messages: MessageItem[] }) {
  const groups = groupMessagesByDay(messages);

  if (!groups.length) {
    return <p className="pb-messages-empty-thread">No messages in this conversation.</p>;
  }

  return (
    <div className="pb-messages-list" aria-label="Conversation messages">
      {groups.map((group) => (
        <section key={group.key} className="pb-messages-day-group">
          <h2><span>{group.label}</span></h2>
          {group.messages.map((message) => (
            <article
              key={message.id}
              className="pb-messages-bubble"
              data-mine={message.mine}
            >
              <header>
                <span>
                  <strong>{message.mine ? "You" : message.sender.display}</strong>
                  {!message.mine ? <small>@{message.sender.handle}</small> : null}
                  {!message.mine ? <RoleChip role={message.sender.role} /> : null}
                </span>
                <time dateTime={message.createdAt}>{formatMessageTime(message.createdAt)}</time>
              </header>
              <MarkdownLite className="pb-messages-markdown">{message.body}</MarkdownLite>
            </article>
          ))}
        </section>
      ))}
    </div>
  );
}

function formatMessageTime(value: string): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return value;
  return new Intl.DateTimeFormat("en-AU", {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}
